import MenuGrid from "../menu-grid/menuGridComponent.vue";
import Contact from "../contact/contactComponent.vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default {
    name: "CompleteList",

    components: { MenuGrid, Contact },

    props: {},

    data: () => {
        return {
            insuranceSections: [
                {
                    category: "Asigurări auto",
                    subcategories: [
                        {
                            title: "Asigurarea auto facultativă de tip Casco",
                            items: []
                        },
                        {
                            title:
                                "Asigurarea obligatorie de răspundere civilă pentru prejudicii produse prin accidente de vehicule (RCA)",
                            items: []
                        },
                        {
                            title:
                                "Documentul internațional de asigurare “Carte Verde”",
                            items: []
                        },
                        {
                            title:
                                "Asigurarea de răspundere a transportatorului pentru mărfurile transportate (CMR)",
                            items: []
                        },
                        {
                            title:
                                "Asigurarea de răspundere a operatorului de transport rutier (ROTr)",
                            items: []
                        }
                    ]
                },
                {
                    category: "Asigurări de bunuri",
                    subcategories: [
                        {
                            title:
                                "Asigurări de incendiu și alte daune la proprietăți",
                            items: [
                                "Asigurări facultative de locuințe și de bunuri din locuințe",
                                "Asigurarea obligatorie de locuințe PAD",
                                "Asigurări de proprietăți industriale și comerciale",
                                "Asigurarea echipamentelor electronice",
                                "Asigurarea de construcții-montaj"
                            ]
                        },
                        {
                            title: "Asigurarea bunurilor în tranzit(CARGO)",
                            items: []
                        }
                    ]
                },
                {
                    category: "Asigurări de persoane",
                    subcategories: [
                        {
                            title:
                                "Asigurări de accidente și boală, inclusiv accidente de muncă și boli profesionale",
                            items: []
                        },
                        { title: "Asigurări de sănătate", items: [] },
                        { title: "Asigurări de călătorie", items: [] },
                        { title: "Asigurări de viață", items: [] }
                    ]
                },
                {
                    category: "Asigurări de răspunderi civile",
                    subcategories: [
                        {
                            title: "Legale",
                            items: [
                                "Răspundere civilă legală față de terți",
                                "Răspundere civilă legală a chiriașului față de proprietar",
                                "Răspundere civilă legală a proprietarului față de chiriaș"
                            ]
                        },
                        {
                            title: "Contractuale",
                            items: [
                                "Răspundere civilă profesională a medicilor, a farmaciștilor",
                                "Răspundere civilă profesională a avocaților",
                                "Răspundere civilă profesională a experților contabili și a contabililor autorizați",
                                "Răspundere civilă profesională a arhitecților și inginerilor constructori",
                                "Răspundere civilă profesională a notarilor publici"
                            ]
                        }
                    ]
                },
                {
                    category: "Asigurări de risc financiar",
                    subcategories: [
                        { title: "Asigurările de credite", items: [] },
                        {
                            title: "Asigurările de garanții",
                            items: [
                                "Garanții de participare la licitație",
                                "Garanții de bună execuție"
                            ]
                        }
                    ]
                },
                {
                    category: "Asigurări agricole",
                    subcategories: []
                }
            ]
        };
    },
    created() {},

    computed: {
        listOfInsurance: function() {
            const list = [];
            this.insuranceSections.forEach(item => {
                //list.push(item.category);
                item.subcategories.forEach(item => {
                    list.push(item.title);
                    list.push(...item.items);
                });
            });

            return list;
        }
    },

    methods: {
        scrollToHash() {
            const section = this.$router.currentRoute.hash.replace("#", "");
            if (section) {
                const element = document.querySelector(`#${section}`);
                element.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }},

    mounted() {
        gsap.registerPlugin(ScrollTrigger);

        setTimeout(() => this.scrollToHash(), 100);

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".TT-wrapper__menu-grid",
                start: "top 100px",
                markers: false,
                anticipatePin: true
            }
        });
        setTimeout(() => {
            let gridItemsSelector = ".TT-menu-grid__content > div";
            if (window.innerWidth >= 768) {
                gridItemsSelector += ":not(:first-child)";
            }
            timeline
                .to(gridItemsSelector, {
                    x: 20,
                    stagger: 0.1,
                    duration: 0.5,
                    ease: "power2.out"
                })
                .to(
                    gridItemsSelector,
                    {
                        x: 0,
                        scale: 1,
                        stagger: 0.1,
                        duration: 1,
                        ease: "elastic"
                    },
                    "-=0.5"
                );
        }, 2000);
    }
};
